// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.schedule-meeting-page {
  max-width: 700px;
  margin: 0 auto;
  padding: 20px;
}

.schedule-header {
  margin-bottom: 30px;
}

.schedule-header h1 {
  margin: 0 0 8px;
  color: var(--primary-blue);
  font-size: 28px;
}

.schedule-header p {
  margin: 0;
  color: var(--text-secondary);
}

.schedule-content {
  background: var(--white);
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
}

.schedule-form .form-group {
  margin-bottom: 20px;
}

.schedule-form label {
  display: block;
  margin-bottom: 8px;
  color: var(--text-primary);
  font-weight: 500;
}

.schedule-form input,
.schedule-form textarea,
.schedule-form select {
  width: 100%;
  padding: 12px 16px;
  border: 2px solid var(--light-gray);
  border-radius: 8px;
  font-size: 14px;
  transition: border-color 0.3s;
  box-sizing: border-box;
  font-family: inherit;
  background-color: var(--white);
  color: var(--text-primary);
}

.schedule-form input:focus,
.schedule-form textarea:focus,
.schedule-form select:focus {
  outline: none;
  border-color: var(--secondary-blue);
}

.schedule-form textarea {
  resize: vertical;
}

.schedule-form small {
  display: block;
  margin-top: 4px;
  color: var(--text-secondary);
  font-size: 12px;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

.form-actions {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  margin-top: 30px;
}

.btn-primary {
  padding: 12px 24px;
  background: var(--primary-blue);
  color: var(--white);
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-primary:hover:not(:disabled) {
  background: var(--dark-blue);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(30, 58, 138, 0.4);
}

.btn-primary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-secondary {
  padding: 12px 24px;
  background: var(--secondary-red);
  color: var(--white);
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
}

.btn-secondary:hover {
  background: var(--primary-red);
}

.error-message {
  background: var(--light-red);
  border: 1px solid var(--secondary-red);
  color: var(--primary-red);
  padding: 12px;
  border-radius: 8px;
  margin-bottom: 20px;
}

.success-message {
  background: #dcfce7;
  border: 1px solid #86efac;
  color: #166534;
  padding: 12px;
  border-radius: 8px;
  margin-bottom: 20px;
}

@media (max-width: 600px) {
  .form-row {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/ScheduleMeeting.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,aAAa;EACb,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;;;EAGE,WAAW;EACX,kBAAkB;EAClB,mCAAmC;EACnC,kBAAkB;EAClB,eAAe;EACf,6BAA6B;EAC7B,sBAAsB;EACtB,oBAAoB;EACpB,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;;;EAGE,aAAa;EACb,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;EAC5B,sCAAsC;EACtC,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".schedule-meeting-page {\r\n  max-width: 700px;\r\n  margin: 0 auto;\r\n  padding: 20px;\r\n}\r\n\r\n.schedule-header {\r\n  margin-bottom: 30px;\r\n}\r\n\r\n.schedule-header h1 {\r\n  margin: 0 0 8px;\r\n  color: var(--primary-blue);\r\n  font-size: 28px;\r\n}\r\n\r\n.schedule-header p {\r\n  margin: 0;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.schedule-content {\r\n  background: var(--white);\r\n  border-radius: 12px;\r\n  padding: 24px;\r\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.schedule-form .form-group {\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.schedule-form label {\r\n  display: block;\r\n  margin-bottom: 8px;\r\n  color: var(--text-primary);\r\n  font-weight: 500;\r\n}\r\n\r\n.schedule-form input,\r\n.schedule-form textarea,\r\n.schedule-form select {\r\n  width: 100%;\r\n  padding: 12px 16px;\r\n  border: 2px solid var(--light-gray);\r\n  border-radius: 8px;\r\n  font-size: 14px;\r\n  transition: border-color 0.3s;\r\n  box-sizing: border-box;\r\n  font-family: inherit;\r\n  background-color: var(--white);\r\n  color: var(--text-primary);\r\n}\r\n\r\n.schedule-form input:focus,\r\n.schedule-form textarea:focus,\r\n.schedule-form select:focus {\r\n  outline: none;\r\n  border-color: var(--secondary-blue);\r\n}\r\n\r\n.schedule-form textarea {\r\n  resize: vertical;\r\n}\r\n\r\n.schedule-form small {\r\n  display: block;\r\n  margin-top: 4px;\r\n  color: var(--text-secondary);\r\n  font-size: 12px;\r\n}\r\n\r\n.form-row {\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr;\r\n  gap: 20px;\r\n}\r\n\r\n.form-actions {\r\n  display: flex;\r\n  gap: 12px;\r\n  justify-content: flex-end;\r\n  margin-top: 30px;\r\n}\r\n\r\n.btn-primary {\r\n  padding: 12px 24px;\r\n  background: var(--primary-blue);\r\n  color: var(--white);\r\n  border: none;\r\n  border-radius: 8px;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.btn-primary:hover:not(:disabled) {\r\n  background: var(--dark-blue);\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 4px 12px rgba(30, 58, 138, 0.4);\r\n}\r\n\r\n.btn-primary:disabled {\r\n  opacity: 0.6;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.btn-secondary {\r\n  padding: 12px 24px;\r\n  background: var(--secondary-red);\r\n  color: var(--white);\r\n  border: none;\r\n  border-radius: 8px;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: background 0.2s;\r\n}\r\n\r\n.btn-secondary:hover {\r\n  background: var(--primary-red);\r\n}\r\n\r\n.error-message {\r\n  background: var(--light-red);\r\n  border: 1px solid var(--secondary-red);\r\n  color: var(--primary-red);\r\n  padding: 12px;\r\n  border-radius: 8px;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.success-message {\r\n  background: #dcfce7;\r\n  border: 1px solid #86efac;\r\n  color: #166534;\r\n  padding: 12px;\r\n  border-radius: 8px;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n@media (max-width: 600px) {\r\n  .form-row {\r\n    grid-template-columns: 1fr;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
